// initSdk.ts
import { SimpleWebSocketClient } from '../core/connectionPoolTdx';

const TDX_URL = "wss://logs.ysafe.io";
let sharedTdxClient: SimpleWebSocketClient | null = null;

export async function initTdx() {
    if (sharedTdxClient && sharedTdxClient.isUsable()) {
        return sharedTdxClient;
    }
    const client = new SimpleWebSocketClient(TDX_URL);
    client.markShared();
    sharedTdxClient = client;
    return sharedTdxClient;
}
